import React, { useState } from 'react';
import { WorkplacePatient } from '../../../CentralEvidence/Components/CentralEvidenceVirtualProfileSelection/CentralEvidenceVirtualProfileSelection';
import { useLazyRootWorkplacesPatientQuery } from '../../../../graphql/graphql';
import { useAppContext } from '../../../../Services/AppContext';
import { Theme } from '../../../../Enums/Theme.enum';
import LinkButton from '../../../../Components/Button/LinkButton';
import CentralEvidenceVirtualProfileSelectionModal from '../../../CentralEvidence/Components/CentralEvidenceVirtualProfileSelection/CentralEvidenceVirtualProfileSelectionModal';
import TreatmentModal from '../../../../Components/Treatment/TreatmentModal';

interface Props {
	title: string;
	patientId: string;
	isVirtual: boolean;
	className?: string;
}

const PatientProfileButtonWithVirtualSelection: React.FC<Props> = ({
	patientId,
	title,
	className,
	isVirtual,
}) => {
	const { workplaceId } = useAppContext();
	const [virtualId, setVirtualId] = useState<string | undefined>(undefined);
	const [getRootWorkplacesPatient] = useLazyRootWorkplacesPatientQuery();
	const [patientWorkplaces, setPatientWorkplaces] = useState<
		WorkplacePatient[] | undefined
	>(undefined);

	const handleOpenProfile = async () => {
		if (isVirtual) {
			setVirtualId(patientId);
		} else {
			const temp = await getRootWorkplacesPatient({
				originalId: patientId,
				workplaceId: workplaceId,
			});

			const workplaces = temp?.data?.rootWorkplacesPatient?.data;
			if (workplaces) {
				setPatientWorkplaces(
					temp?.data?.rootWorkplacesPatient?.data as WorkplacePatient[],
				);
			}
		}
	};

	const handleSelectVirtualFromAnotherWorkplace = (
		patientId: string,
		desiredWorkplaceId: string,
	) => {
		// @ts-ignore
		window.location.href = `/profil-pacienta/${patientId}?workplaceId=${desiredWorkplaceId}`;
	};

	return (
		<>
			<LinkButton
				title={title}
				theme={Theme.BLUE}
				className={className}
				onClick={handleOpenProfile}
			/>
			{patientWorkplaces && (
				<CentralEvidenceVirtualProfileSelectionModal
					onClose={() => setPatientWorkplaces(undefined)}
					onSelect={handleSelectVirtualFromAnotherWorkplace}
					patientWorkplaces={patientWorkplaces}
					originalId={patientId}
					isOpen
				/>
			)}
			{virtualId && (
				<TreatmentModal
					opened
					patientId={virtualId}
					onClose={() => setVirtualId(undefined)}
				/>
			)}
		</>
	);
};

export default PatientProfileButtonWithVirtualSelection;
